<template>
<div id="schedule">
  <div v-for="program in todaysSchedule" :key="program" class="schedule__container">
      <div class="schedule__container__cover">
        <img :src="program.cover"/>
      </div>
      <div class="schedule__container__text">
        <p class="schedule__container__text__title"><strong>{{ program.title }}</strong></p>
        <p class="schedule__container__text__dj">{{ program.name }}</p>
        <p class="schedule__container__text__time">{{ program.startTime }} - {{program.endTime}}</p>
  </div>
  </div>
  </div>
</template>

<script>
import json from "@/assets/radioplayer/radio-programming.json";
export default {
  data() {
    return {
      now: Date.now(),
      todaysSchedule: []
    };
  },
  mounted() {
    this.returnScheduleContainers();
  },
  methods: {
    returnScheduleContainers() {
      const date = new Date(this.now);
      for (let i = 0; i < json.programming.length; i++) {
        if (i == date.getDay()) {
          if (i == 0) {
            i = 7;
          }
          let dayKey = Object.keys(json.programming[i - 1])[0];
          for (let j = 0; j < json.programming[i - 1][dayKey].length; j++) {
            let startTime = Object.keys(json.programming[i - 1][dayKey][j])[0].split("-")[0];
            let endTime = Object.keys(json.programming[i - 1][dayKey][j])[0].split("-")[1];
            let cover = require("@/assets/radioplayer/"+json.programming[i -1][dayKey][j][startTime+"-"+endTime][0]["cover"]+".png");
            let title = json.programming[i -1][dayKey][j][startTime+"-"+endTime][0]["title"];
            let name = json.programming[i -1][dayKey][j][startTime+"-"+endTime][0]["name"];
            this.todaysSchedule.push({
                startTime: startTime,
                endTime: endTime,
                cover: cover,
                title: title,
                name: name
            })
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
$schedule__text--font: "Lato";
$schedule__text--colour-time: #ff6600;


#schedule {
  margin: auto;
  font-family: $schedule__text--font;
  font-size: 14px;
  
  .schedule__container {
    display: grid;
    grid-template-columns: 100px 1fr;
    margin-bottom: 12px;
    height: 100px;
      
    .schedule__container__cover {
      img {
        height: auto;
        width: 100px;
      }
    }
    .schedule__container__text {
      padding-left: 12px;
      font-size: 14px;
      position: relative;

      .schedule__container__text__title {
        font-weight: bold;
      }
      .schedule__container__text__dj {
        
      }
      .schedule__container__text__time {
        color: $schedule__text--colour-time;
        font-weight: bold;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
</style>